import { render, staticRenderFns } from "./Welcoming.vue?vue&type=template&id=59f6d178"
import script from "./Welcoming.vue?vue&type=script&lang=js"
export * from "./Welcoming.vue?vue&type=script&lang=js"
import style0 from "./Welcoming.vue?vue&type=style&index=0&id=59f6d178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports